import Order, {
  OrderOrigin,
  Status as OrderStatus,
} from 'easyjs/lib/Schema/Order';
import Builder from 'easyjs/lib/Schema/Components/Builder';
import { Http } from 'easyjs';
import store from '@/store';
import Delivery, { DeliveryType } from 'easyjs/lib/Schema/Delivery';
import FakeOrders from '@/utils/fakeOrders.json';

const { Response } = Http;

let localOrders = [];

export class OrderFakeApi {
  static getProductTemplate() {
    const productTypes = ['pizza', 'step', 'drink'];
    const randomProductType = Math.floor(Math.random() * productTypes.length);
    const randomQuantity = Math.floor(Math.random() * 5) + 1;
    switch (productTypes[randomProductType]) {
      case 'pizza':
        return {
          type: 'pizza',
          name: 'Pizza tradicional',
          sizes: [{ _id: 1, type: 'size', name: 'Grande', price: 49.9 }],
          items: [
            {
              type: 'flavor',
              name: 'Sabor 1',
              quantity: 1,
              sizes: [{ _id: 1, type: 'size', name: 'Grande', price: 49.9 }],
            },
            {
              type: 'flavor',
              name: 'Sabor 2',
              quantity: 1,
              sizes: [{ _id: 1, type: 'size', name: 'Grande', price: 49.9 }],
            },
          ],
        };
      case 'step':
        return {
          type: 'step',
          quantity: randomQuantity,
          name: 'Produto Etapas - Teste',
          categoryName: 'Categoria de Etapas',
          sizes: [{ _id: 1, type: 'size', name: 'Tamanho Único', price: 9 }],
          items: [
            {
              type: 'question',
              quantity: 1,
              name: 'Questão de Etapas - Teste',
              items: [
                {
                  type: 'option',
                  quantity: 1,
                  name: 'Opção de Etapas - Teste',
                  price: 1,
                },
              ],
            },
            {
              type: 'question',
              quantity: 1,
              name: 'Questão de Etapas 2 - Teste',
              items: [
                {
                  type: 'option',
                  quantity: 1,
                  name: 'Opção de Etapas - Teste',
                  price: 1,
                },
                {
                  type: 'option',
                  quantity: 2,
                  name: 'Opção de Etapas 2 - Teste',
                  price: 2,
                },
              ],
            },
          ],
        };
      case 'drink':
        return {
          type: 'drink',
          quantity: randomQuantity,
          name: 'Produto Bebida - Teste',
          categoryName: 'Categoria de Bebidas',
          sizes: [{ _id: 1, type: 'size', name: 'Tamanho Único', price: 9 }],
          items: [],
        };
        return;
    }
  }

  static getOrderTemplate() {
    const fakeId = Math.floor(Math.random() * 100);
    const localOrdersCount = localOrders.length;
    // Resultado é o pedido na posição igual ao resto da divisão do total de pedidos pelo total de pedidos do template...
    // Com esse resto de divisão os pedidos serão retornados na seguinte ordem: 0, 1, 2, 3, 4, 5, 0, 1 , 2, 3, 4...
    const order = JSON.parse(
      JSON.stringify(FakeOrders[localOrdersCount % FakeOrders.length])
    );
    order.id = fakeId;
    order.created_at = new Date().getTime();
    return order;
  }

  static new() {
    const order = Order.fromObject(OrderFakeApi.getOrderTemplate());
    localOrders.push(order);
    if (order.origin === 1)
      store.dispatch('socket/setSocketResponse', {
        notification: 'newOrders',
        data: JSON.parse(JSON.stringify(order)),
      });
    else
      store.dispatch('socket/setNewAcceptedOrder', {
        notification: 'newAcceptedOrder',
        data: JSON.parse(JSON.stringify(order)),
      });
  }

  static getLocalOrder(orderId) {
    const filteredLocalOrders = localOrders.filter(
      (order) => order.id == orderId
    );
    if (filteredLocalOrders.length > 0) {
      return filteredLocalOrders[0];
    }
    return null;
  }

  static localOrdersExists(orderId) {}

  static listAll() {}

  static checkOrderHasTerm(order, term) {
    if (`${order.order_id || ''}`.indexOf(term) > -1) {
      return true;
    }

    if (`${order.position || ''}`.indexOf(term) > -1) {
      return true;
    }

    if (order.delivery && order.delivery.address) {
      const { address } = order.delivery;
      if ((address.address || '').toLowerCase().indexOf(term) > -1) return true;
      if ((address.region || '').toLowerCase().indexOf(term) > -1) return true;
      if ((address.number || '').toLowerCase().indexOf(term) > -1) return true;
    }

    for (const p of order.payment.payers) {
      if (
        (p.user.name || '').toLowerCase().indexOf(term) > -1 ||
        (p.user.phone || '').toLowerCase().indexOf(term) > -1
      ) {
        return true;
      }
    }

    return false;
  }

  static list({ term, periods }) {
    const inProduction = [];
    const delivery = [];
    const finished = [];
    const count = [];

    let filteredOrder = localOrders;

    // Se termo for do tipo string e tiver algum valor real
    if (typeof term === `string` && !!term) {
      term = term.toLowerCase();
      filteredOrder = filteredOrder.filter((o) =>
        OrderFakeApi.checkOrderHasTerm(o, term)
      );
    }

    if (Array.isArray(periods) && periods.length > 0) {
      // Filtrar primeiro a data inicial
      const periodStatTime = periods[0].getTime();
      filteredOrder = filteredOrder.filter(
        (o) => o.created_at >= periodStatTime
      );

      // Se data final for definida, filtrar pela data final também
      if (periods.length > 1) {
        const periodEndTime = periods[1].getTime();
        filteredOrder = filteredOrder.filter((o) => {
          console.log(
            new Date().toISOString(),
            new Date(o.created_at).toISOString(),
            new Date(periodEndTime).toISOString()
          );
          return o.created_at <= periodEndTime;
        });
      }
    }

    // Realiza a montagem do formato de resposta
    filteredOrder.forEach((order) => {
      switch (order.status) {
        case OrderStatus.IN_PRODUCTION:
          inProduction.push(order);
          count.push({ id: order.id, status: order.status });
          break;
        case OrderStatus.ON_DELIVERY:
          delivery.push(order);
          count.push({ id: order.id, status: order.status });
          break;
        case OrderStatus.FINISHED:
          finished.push(order);
          count.push({ id: order.id, status: order.status });
          break;
      }
    });

    return new Response({
      in_production: inProduction,
      delivery,
      finished,
      count,
    });
  }

  static clearOrders() {
    localOrders = [];
  }

  /* Rejeita um pedido */
  static reject(orderId) {
    const order = OrderFakeApi.getLocalOrder(orderId);
    if (order) {
      order.status = OrderStatus.REJECTED;
    }
    return new Response(order);
  }

  /* Cancela um pedido */
  static cancel(orderId) {
    const order = OrderFakeApi.getLocalOrder(orderId);
    if (order) {
      order.status = OrderStatus.CANCELLED;
    }

    store.dispatch('socket/setNewCanceledOrder', {
      notification: 'newCanceledOrder',
      data: JSON.parse(JSON.stringify(order)),
    });
    return new Response(order);
  }

  /* Aceita um pedido */
  static accept(orderId) {
    const order = OrderFakeApi.getLocalOrder(orderId);
    if (order) {
      order.status = OrderStatus.IN_PRODUCTION;
    }

    store.dispatch('socket/setNewAcceptedOrder', {
      notification: 'newAcceptedOrder',
      data: JSON.parse(JSON.stringify(order)),
    });
    return new Response(order);
  }

  /* Entrega um pedido */
  static deliver(orderId) {
    const order = OrderFakeApi.getLocalOrder(orderId);
    if (order) {
      const originalStatus = order.status;
      order.status = OrderStatus.ON_DELIVERY;
      store.dispatch('socket/setNewChangeOrderStatus', {
        notification: 'newChangeOrderStatus',
        data: {
          data: {
            originalStatus,
            status: OrderStatus.ON_DELIVERY,
          },
        },
      });
      return new Response(order);
    }
    return null;
  }

  /* Finaliza um pedido */
  static finish(orderId) {
    const order = OrderFakeApi.getLocalOrder(orderId);
    if (order) {
      const originalStatus = order.status;
      order.status = OrderStatus.FINISHED;
      store.dispatch('socket/setNewChangeOrderStatus', {
        notification: 'newChangeOrderStatus',
        data: {
          data: {
            originalStatus,
            status: OrderStatus.FINISHED,
          },
        },
      });
      return new Response(order);
    }
    return null;
  }
}
